<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog" role="document">
			<div v-if="product && provider" class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button @click="close()" type="button" class="close" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4 class="modal-title">
						Generar pedido a {{ product.title }}
					</h4>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<template v-if="provider.orders">
								<template v-if="provider.orders.length">
									<label>Pedidos existentes:</label>
									<select v-model="order" class="form-control">
										<option v-for="order in provider.orders" :value="order">
											{{ $platform.setting.number_symbol }}{{ order.id }}
											<template v-if="order.status">
												<label :class="'label label-' + order.status.class">
													<template v-if="order.status.lang">
														- {{ order.status.lang.name }}
													</template>
													<template v-else>
														- {{ order.status.name }}
													</template>
												</label>
											</template>
											- {{ order.created_at | moment }}
										</option>
									</select>
								</template>
							</template>
						</div>
					</div>
					<hr>
					<div class="row">
						<div class="col-md-6">
							<button @click="addProductToOrder" class="btn btn-success btn-block btn-lg">
								Añadir a pedido existente
							</button>
						</div>
						<div class="col-md-6">
							<button @click="generateOrderProvider" class="btn btn-success btn-block btn-lg">
								Nuevo pedido
							</button>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button @click="close()" type="button" class="btn btn-default">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	export default {
		props: ['user', 'isAuth', 'data'],
		data () {
			return {
				modal: {
					selector: 'modal-generate-order-provider-' + Math.floor(Math.random() * 736456),
				},

				provider: null,
				product: null,

				order: null,
			}
		},
		methods: {
			open(product, provider) {
				if(provider) {
					this.provider = provider
					if(this.provider.orders) {
						if(this.provider.orders.length) {
							this.order = this.provider.orders[0]
						}
					}
				}
				if(product) {
					this.product = product
				}
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			addProductToOrder() {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: "¿Esta seguro de añadir este producto al pedido?",
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						var data = {
							parent_id: that.data.id,
							provider_id: that.provider.id,
						}
						return new Promise(function (resolve) {
							that.$http.get('admin/management/orders/' + that.order.id + '/add/product/storage/' + that.product.id)
							.then(response => {
								that.$emit('reload')
								that.close()
								swal(response.body.title, response.body.text, response.body.type)
							}).catch(function(response) {
								if(response.status == 409) {
									swal(response.body.title, response.body.text, response.body.type);
								} else {
									swal({
										title: response.statusText,
										text: response.body,
										type: "warning"
									});
								}
							})
						})
					}
				}]).catch(swal.noop)
			},
			generateOrderProvider() {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.purchase_order_will_be_added"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						var data = {
							tax_id: that.data.tax_id,
							currency_id: that.data.currency_id,
							lang_id: that.data.lang_id,
							parent_id: that.data.id,
							provider_id: that.provider.id,
							products: [
								that.product
							]
						}
						return new Promise(function (resolve) {
							that.$http.post('admin/management/orders', data)
							.then(response => {
								that.$emit('reload')
								that.close()
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								if(response.status == 409) {
									swal(response.body.title, response.body.text, response.body.type);
								} else {
									swal({
										title: response.statusText,
										text: response.body,
										type: "warning"
									});
								}
							})
						})
					}
				}]).catch(swal.noop)
			},
		},
	};
</script>


// WEBPACK FOOTER //
// src/components/management/orders/views/GenerateOrderProvider.vue